var map = {
	"./baterias.svg": "./src/assets/icons/solar/baterias.svg",
	"./bateriasAlimentacaoDC.svg": "./src/assets/icons/solar/bateriasAlimentacaoDC.svg",
	"./corrente.svg": "./src/assets/icons/solar/corrente.svg",
	"./energiaAcumulada.svg": "./src/assets/icons/solar/energiaAcumulada.svg",
	"./energiaConexao.svg": "./src/assets/icons/solar/energiaConexao.svg",
	"./energiaRestante.svg": "./src/assets/icons/solar/energiaRestante.svg",
	"./entradaAlimentacao.svg": "./src/assets/icons/solar/entradaAlimentacao.svg",
	"./estaSemana.svg": "./src/assets/icons/solar/estaSemana.svg",
	"./estadoDeCarga.svg": "./src/assets/icons/solar/estadoDeCarga.svg",
	"./hoje.svg": "./src/assets/icons/solar/hoje.svg",
	"./irradiacao.svg": "./src/assets/icons/solar/irradiacao.svg",
	"./media_consumo.svg": "./src/assets/icons/solar/media_consumo.svg",
	"./modoOperacional.svg": "./src/assets/icons/solar/modoOperacional.svg",
	"./nesteAno.svg": "./src/assets/icons/solar/nesteAno.svg",
	"./nesteMes.svg": "./src/assets/icons/solar/nesteMes.svg",
	"./ontem.svg": "./src/assets/icons/solar/ontem.svg",
	"./potenciaDeCarga.svg": "./src/assets/icons/solar/potenciaDeCarga.svg",
	"./saidaAlimentacao.svg": "./src/assets/icons/solar/saidaAlimentacao.svg",
	"./saidaEnergia.svg": "./src/assets/icons/solar/saidaEnergia.svg",
	"./temperatura.svg": "./src/assets/icons/solar/temperatura.svg",
	"./temperaturaAmbiente.svg": "./src/assets/icons/solar/temperaturaAmbiente.svg",
	"./temperaturaDoModulo.svg": "./src/assets/icons/solar/temperaturaDoModulo.svg",
	"./tensao.svg": "./src/assets/icons/solar/tensao.svg",
	"./tensaoDC.svg": "./src/assets/icons/solar/tensaoDC.svg",
	"./total.svg": "./src/assets/icons/solar/total.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/icons/solar sync recursive ^\\.\\/.*$";